/* eslint-disable react/no-deprecated */
import ReactDOM from "react-dom";
import ReactDomRenderer from "react-dom/client";
import { RecoilRoot } from "recoil";

import SimpliciAuthContainer from "simplici-auth-container";
import { SITE_META } from "utils/site_meta";
import { ENVS } from "constants/common";

import "./index.scss";

const root = document.getElementById("simplici-authenticaion");

if (root) {
  const rootContainer = ReactDomRenderer.createRoot(root);
  rootContainer.render(
    <RecoilRoot>
      <div className="simplici-auth-wrapper">
        <SimpliciAuthContainer />
      </div>
    </RecoilRoot>
  );
} else {
  customElements.define(
    "simplici-auth",
    class extends HTMLElement {
      connectedCallback() {
        const props: Record<string, any> = {};
        const attributes = this.getAttributeNames();

        attributes.forEach((attr) => {
          const propData = this.getAttribute(attr);
          if (
            window[propData as any] &&
            typeof window[propData as any] === "function"
          ) {
            props[attr] = window[propData as any];
          } else {
            props[attr] = propData;
          }
        });

        const disabledDhadowDOm = true;
        if (props.env !== ENVS.DEV && !disabledDhadowDOm) {
          const shadowRoot = this.attachShadow({
            mode: "open",
          }); // Create a shadow DOM

          const head = document.getElementsByTagName("head")?.[0]; // Get the head element

          // Create a <link> element for your CSS file
          const linkElem = document.createElement("link");
          linkElem.setAttribute("rel", "stylesheet");
          linkElem.setAttribute(
            "href",
            `${
              SITE_META[(props.env as "prod") ?? "prod"].url
            }/static/css/main.css`
          );

          const fontLink = document.createElement("link"); // Create a <link> element for Google Fonts
          fontLink.href =
            "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap";
          fontLink.rel = "stylesheet";
          fontLink.type = "text/css";
          fontLink.media = "all";

          // Append the <link> element to the shadow DOM
          head?.appendChild(fontLink);

          shadowRoot.appendChild(this);
          // shadowRoot.appendChild(mountPoint);
          shadowRoot.appendChild(linkElem);
        } else {
          const head = document.getElementsByTagName("head")?.[0]; // Get the head element

          // Create a <link> element for your CSS file
          const linkElem = document.createElement("link");
          linkElem.setAttribute("rel", "stylesheet");
          linkElem.setAttribute(
            "href",
            `${
              SITE_META[(props.env as "prod") ?? "prod"].url
            }/static/css/main.css`
          );

          const remixIocon = document.createElement("link");
          remixIocon.setAttribute("rel", "stylesheet");
          remixIocon.setAttribute(
            "href",
            "https://cdn.jsdelivr.net/npm/remixicon@4.3.0/fonts/remixicon.css"
          );

          head?.appendChild(linkElem);
          head?.appendChild(remixIocon);
        }
        // eslint-disable-next-line react/no-deprecated
        ReactDOM.render(
          <RecoilRoot>
            <div className="simplici-auth-wrapper" id="simplici-auth-wrapper">
              <SimpliciAuthContainer {...props} />
            </div>
          </RecoilRoot>,
          this
        );
      }
      disconnectedCallback() {
        // eslint-disable-next-line react/no-deprecated
        ReactDOM.unmountComponentAtNode(this);
      }

      static get observedAttributes() {
        return [
          "instance_id",
          "page",
          "env",
          "on_step_change",
          "on_error",
          "on_loaded",
          "on_complete",
          "lang",
          "iscombinedInput",
          "platform",
          "hide_navigation",
          "auto_navigate",
          "sso_user_data",
          "microsoft_redirect_url",
          "facebook_redirect_url",
          "apple_redirect_url",
          "google_redirect_url",
          "styles",
          "support_signin_methods",
        ];
      }

      attributeChangedCallback(_: string, oldValue: any, newValue: any) {
        if (newValue !== oldValue) {
          this.connectedCallback();
        }
      }
    }
  );
}
